import React from 'react';
import './shared/styles/App.scss';
import ChevronChart from './components/chevron-chart/chevron-chart';

function App() {
  return <ChevronChart />;
}

export default App;
